import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MuiSnackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Alert from '../Alert';
import SnackbarAction from './SnackbarAction';

const useStyles = makeStyles(
  ({ palette }) => ({
    root: {
      '& .cncui-snackbar-alert': {
        alignItems: 'flex-start',
        position: 'relative',
        boxShadow: palette.cncUI.shadow.container.hover,
        '& .cncui-alert-icon': {
          marginTop: 6,
        },
        '& .cncui-alert-message': {
          marginTop: 10,
          marginRight: 52,
          marginBottom: 8,
          '& .cncui-snackbar-alert-title': {
            fontWeight: 700,
            display: 'block',
            marginBottom: 4,
            marginTop: -4,
          },
        },
        '& .cncui-snackbar-alert-close': {
          position: 'absolute',
          top: 13,
          right: 13,
        },
        '& .cncui-snackbar-action': {
          minWidth: 100,
          alignSelf: 'flex-end',
          marginTop: 16,
          marginBottom: -4,
          marginRight: -40,
        },
      },
    },
    inline: {
      '& .cncui-snackbar-alert': {
        '& .cncui-alert-message': {
          flexDirection: 'row',
          '& .cncui-snackbar-alert-title': {
            marginTop: 0,
            marginRight: 8,
          },
          '& .cncui-snackbar-action': {
            margin: '-6px 0 0 8px',
          },
        },
      },
    },
  }),
  { name: 'CncUI-Snackbar' },
);

const Snackbar = props => {
  const classes = useStyles();
  const {
    children,
    title,
    position = 'top-center',
    variant,
    inline,
    hideDuration,
    onClose,
    className,
    ...other
  } = props;

  const [vertical, horizontal] = position.split('-');
  const options = {
    onClose,
    className: clsx(
      'cncui-snackbar',
      classes.root,
      inline && classes.inline,
      className,
    ),
    autoHideDuration: hideDuration || null,
    anchorOrigin: { vertical, horizontal },
  };

  return (
    <MuiSnackbar {...options} {...other}>
      <Alert
        className="cncui-snackbar-alert"
        info={variant === 'info'}
        success={variant === 'success'}
        warning={variant === 'warning'}
        error={variant === 'error'}
      >
        {onClose && (
          <IconButton
            className="cncui-snackbar-alert-close"
            size="small"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
        {title && <span className="cncui-snackbar-alert-title">{title}</span>}
        {children}
      </Alert>
    </MuiSnackbar>
  );
};

Snackbar.Action = SnackbarAction;

export default Snackbar;
